import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogFormField from "@/shared/ui/SogFormField.vue";
import SogForm from "@/shared/ui/SogForm.vue";
import PersonDetails from "@/shared/model/personDetails";
import {ref, watch} from "vue";
import PersonDetailsId from "@/shared/model/personDetailsId";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import Person from "@/shared/model/person";

interface Props {
  person?: Person,
  details?: PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'PersonEvbActivationFormComponent',
  props: {
    person: { default: undefined },
    details: { default: undefined }
  },
  setup(__props: any, { expose: __expose }) {

const _form = ref<InstanceType<typeof SogForm> | null>(null)

const props = __props

const _default = ref<number>(0)
const _max = ref<number>(0)


function validate(): boolean {
  return _form.value?.validate() ?? false;
}

watch(props, () => {
  _default.value = props.details?.getNumberValue(PersonDetailsId.EvbActivationDefaultDuration) ?? (props.person?.isBranch() ? 7 : 30)
  _max.value = props.details?.getNumberValue(PersonDetailsId.EvbActivationMaxDuration) ?? (props.person?.isBranch() ? 30 : 90)
}, {immediate: true})

function getDetails(): PersonDetails | undefined {
  if (!validate()) return undefined;
  const details = new PersonDetails(props?.details?.getValues());
  details.setNumberValue(PersonDetailsId.EvbActivationDefaultDuration, _default.value)
  details.setNumberValue(PersonDetailsId.EvbActivationMaxDuration, _max.value)
  return details;
}

__expose({
  validate,
  getDetails
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogForm, {
    ref_key: "_form",
    ref: _form
  }, {
    default: _withCtx(() => [
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogNumericTextBox, {
            modelValue: _default.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_default).value = $event)),
            placeholder: "Standard Anzahl Tage",
            name: "Default",
            format: "N",
            min: 1
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogNumericTextBox, {
            modelValue: _max.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_max).value = $event)),
            placeholder: "Maximale Anzahl Tage",
            name: "max",
            format: "N",
            min: 1
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})